import React from 'react';

const InstrumentReading = ({ formData, updateFormData, nextStep, prevStep, currentStep, totalSteps }) => {
  const handleReadingChange = (temp, type, value) => {
    const newReadings = { ...formData.standardReadings };
    newReadings[temp] = { ...newReadings[temp], [type]: value };
    updateFormData({ standardReadings: newReadings });
  };

  const handleCCUOutputChange = (output, temp, value) => {
    const newOutput = { ...formData[output] };
    newOutput[temp] = value;
    updateFormData({ [output]: newOutput });
  };

  const temperatures = [40, 60, 80, 100, 120, 140];
  const showCCUOutput = formData.accessories === "External CCU";
  const showCCUAndRI = formData.accessories === "External CCU and RI";
  const showCCUAndRI1OP = formData.accessories === "External CCU and RI (1 O/P)";
  const showCCUAndRI2OP = formData.accessories === "External CCU and RI (2 O/P)";
  const showCCUAndRI4OP = formData.accessories === "External CCU and RI (4 O/P)";

  return (
    <div className="form-section">
      <h3>Instrument Reading</h3>
      
      <div className="table-container">
        <table className="test-table">
          <thead>
            <tr>
              <th style={{ width: '50px' }}>No.</th>
              <th>Standard Reading in °C</th>
              {temperatures.map(temp => (
                <th key={temp}>{temp}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>1</td>
              <td><strong>Instrument Reading in °C (forward)</strong></td>
              {temperatures.map(temp => (
                <td key={`forward-${temp}`}>
                  <input
                    type="number"
                    value={formData.standardReadings[temp]?.forward || ''}
                    onChange={(e) => handleReadingChange(temp, 'forward', e.target.value)}
                    placeholder={temp}
                  />
                </td>
              ))}
            </tr>
            <tr>
              <td style={{ textAlign: 'center', fontWeight: 'bold' }}>2</td>
              <td><strong>Instrument Reading in °C (reverse)</strong></td>
              {temperatures.map(temp => (
                <td key={`reverse-${temp}`}>
                  <input
                    type="number"
                    value={formData.standardReadings[temp]?.reverse || ''}
                    onChange={(e) => handleReadingChange(temp, 'reverse', e.target.value)}
                    placeholder="-"
                  />
                </td>
              ))}
            </tr>
            {showCCUOutput && (
              <>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>3</td>
                  <td><strong>CCU O/P-1 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu1-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput1?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput1', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>4</td>
                  <td><strong>CCU O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu2-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput2?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput2', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
            {showCCUAndRI && (
              <>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>5</td>
                  <td><strong>Remote Indicator Reading in °C (CCU output -1)</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-${temp}`}>
                      <input
                        type="number"
                        value={formData.remoteIndicatorCCU1?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorCCU1', temp, e.target.value)}
                        placeholder="0"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>6</td>
                  <td><strong>CCU O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu2-ri-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput2ForRI?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput2ForRI', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
            {showCCUAndRI1OP && (
              <>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>5</td>
                  <td><strong>Remote Indicator Reading in °C (CCU output -1)</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-1op-${temp}`}>
                      <input
                        type="number"
                        value={formData.remoteIndicatorCCU1For1OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorCCU1For1OP', temp, e.target.value)}
                        placeholder="0"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>6</td>
                  <td><strong>CCU O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu2-ri-1op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput2ForRI1OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput2ForRI1OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>7</td>
                  <td><strong>Remote Indicator -O/P-1 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op1-1op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP1ForRI1OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP1ForRI1OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
            {showCCUAndRI2OP && (
              <>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>5</td>
                  <td><strong>Remote Indicator Reading in °C (CCU output -1)</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-2op-${temp}`}>
                      <input
                        type="number"
                        value={formData.remoteIndicatorCCU1For2OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorCCU1For2OP', temp, e.target.value)}
                        placeholder="0"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>6</td>
                  <td><strong>CCU O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu2-ri-2op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput2ForRI2OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput2ForRI2OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>7</td>
                  <td><strong>Remote Indicator -O/P-1 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op1-2op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP1ForRI2OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP1ForRI2OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>8</td>
                  <td><strong>Remote Indicator -O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op2-2op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP2ForRI2OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP2ForRI2OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
            {showCCUAndRI4OP && (
              <>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>5</td>
                  <td><strong>Remote Indicator Reading in °C (CCU output -1)</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-4op-${temp}`}>
                      <input
                        type="number"
                        value={formData.remoteIndicatorCCU1For4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorCCU1For4OP', temp, e.target.value)}
                        placeholder="0"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>6</td>
                  <td><strong>CCU O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`ccu2-ri-4op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.ccuOutput2ForRI4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('ccuOutput2ForRI4OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>7</td>
                  <td><strong>Remote Indicator -O/P-1 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op1-4op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP1ForRI4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP1ForRI4OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>8</td>
                  <td><strong>Remote Indicator -O/P-2 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op2-4op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP2ForRI4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP2ForRI4OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>9</td>
                  <td><strong>Remote Indicator -O/P-3 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op3-4op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP3ForRI4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP3ForRI4OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontWeight: 'bold' }}>10</td>
                  <td><strong>Remote Indicator -O/P-4 IN mA</strong></td>
                  {temperatures.map(temp => (
                    <td key={`remote-op4-4op-${temp}`}>
                      <input
                        type="number"
                        step="0.01"
                        value={formData.remoteIndicatorOP4ForRI4OP?.[temp] || ''}
                        onChange={(e) => handleCCUOutputChange('remoteIndicatorOP4ForRI4OP', temp, e.target.value)}
                        placeholder="0.00"
                      />
                    </td>
                  ))}
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>

      <div className="navigation-buttons">
        <button 
          className="btn btn-secondary" 
          onClick={prevStep}
          disabled={currentStep === 1}
        >
          Previous
        </button>
        <button 
          className="btn btn-primary" 
          onClick={nextStep}
          disabled={currentStep === totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default InstrumentReading;
